/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Price toggles
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;
allSwitches.forEach((value) => {
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    toggleSwitches();
    togglePrices();
    updatePrice();
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelector('.toggle-personal').checked = true : v.querySelector('.toggle-business').checked = true;
  })
  document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
  })
}
let updatePrice = () => {
  let url = priceSwitchForm.getAttribute('action');
  let formData = new FormData(priceSwitchForm);
  fetch(url, {
    method: 'POST',
    processData: false,
    contentType: false,
    body: formData,
    headers: {
      'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then(
    function(response) {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      response.json().then(function(data) {
        document.querySelector("#price-switch [name=_token]").value = data.token;
      });
    }
  ).catch(function(err) {
    console.log('Fetch Error :-S', err);
  });
}
// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed']
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Toggle search bar
  document.getElementById('toggle-search') ? document.getElementById('toggle-search').addEventListener('click', () => {
    document.querySelector('.header-search').classList.toggle('active');
    document.getElementById('toggle-search').classList.toggle('active');
  }) : '';
  document.getElementById('filter-btn') ? document.getElementById('filter-btn').addEventListener('click', () => {
    
    document.querySelector('.header-search').classList.toggle('active');
    document.getElementById('toggle-search').classList.toggle('active');
  }) : '';

// Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : '';

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}

//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}



/**
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //change header text
  let headerSpan = document.getElementsByClassName("header-span");
  for (let i = 0; i < headerSpan.length; i++) {
    (searchType === 'car') ? headerSpan[i].innerHTML = 'Car Lease' : headerSpan[i].innerHTML = 'Van Lease';
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  // loadBodyTypes(document.querySelector('#search-type').value);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers/ev';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      var url = '/api/' + $type + '/models/' + $manufacturer + '/ev';

      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  if($model) {
    var url = '/api/' + $type + '/specs/' + $model;

    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {
      for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}


// Toggl Offer Filters
  // document.getElementById('filter-btn') ? document.getElementById('filter-btn').addEventListener('click', (e) => {e.preventDefault();document.getElementById('filter-btn').classList.toggle('hidden');document.querySelector('#offer-filters').classList.toggle('hidden');}) : '';


//Contact Form
if(document.getElementById('send-contact-form')){

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();
    document.body.classList.remove('loaded');

    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#contact-form [name=email]').value;
        let name = document.querySelector('#contact-form [name=name]').value;
        let telephone = document.querySelector('#contact-form [name=telephone]').value;
        let comments = `Preferred Contact Method: ${document.querySelector('#contact-form [name=preferred]').value} \n`;
        comments += `Preferred Date ${document.querySelector('#contact-form [name=date]').value} \n`;
        comments += `Preferred Time ${document.querySelector('#contact-form [name=time]').value} \n`;
        comments += `----\n Additional Info:\n ${document.querySelector('#contact-form [name=comments]').value}`;
        let token = document.querySelector('#contact-form [name=_token]').value;
        let recaptcha = document.querySelector('input[name=g-recaptcha-response]').value;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({ 'name': name, 'email': email, 'telephone': telephone, 'comments': comments, '_token': token, 'g-recaptcha-response': recaptcha }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status!='ok'){
            let errors = '';
            for (let i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            return alert('There was a problem with your form\n\n'+errors);
          }

          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'Contact Form Submit'
          });

        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });
      });
    });
  });
}

//Email Signup
if(document.getElementById('email-signup')){
  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span class="btn-loading">Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    let url = '/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+$errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+$errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Form Submit'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

//Lazy Load Images
document.addEventListener("DOMContentLoaded", function() {
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();
});

function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    let searchType = document.querySelector('#search-type').value;

    loadManufacturers(searchType);

    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      loadModels(searchType, e.target.value);
    });
  }
}

window.onload = (function(){
  //preloader
  var root = document.getElementsByTagName('html')[0];
  root.classList.add("site-loaded");

  document.body.classList.add("loaded");
  
  loadSearchForm();
});

document.addEventListener('DOMContentLoaded', () => {

  

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.offers-strip#'+sliderID+' .glider-prev',
          next: '.offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Featured Ranges Slider
  const rangeSlider = document.querySelector('#featured-range-track');
  if (rangeSlider) {
    new Glider(rangeSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      dots: '#featured-ranges-nav'
    })
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      }
    })
  }

  // Tools & Calculators Slider
  const toolsSlider = document.querySelector('#tools-strip .services-strip-grid');
  if (toolsSlider) {
    new Glider(toolsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.services-strip-controls .glider-prev',
        next: '.services-strip-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    })

  }

// Toggle class for accordions
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    // modalMobileSearch.close();
    // videoModal.close();
    // hamburgerSearch.classList.remove('is-active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  // Table Sorting
  function sortTable(elem) {
    let sortName = elem.composedPath()[0].dataset.sortname;
    let sortDirection = elem.composedPath()[0].dataset.sortdirection;
    let tableBody = elem.composedPath()[3].childNodes[3];
    let tableRows = Array.from(tableBody.children);

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  // Newsletter strip car animation trigger
  if (document.getElementById("svg_anim")){
    let svgLocation = document.getElementById("svg_anim").getBoundingClientRect();
    let offsetToTriggerAnimation = svgLocation.y + svgLocation.height;
    function scrollAnimTriggerCheck(evt) {
      let viewBottom = window.scrollY + window.innerHeight;
      if (viewBottom > offsetToTriggerAnimation) {
        document.getElementById("svg_car").beginElement();
        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }

  // Calculators
  if (document.querySelector('body').classList.contains('page-tax-calculator') || document.querySelector('body').classList.contains('page-journey-cost-calculator') || document.querySelector('body').classList.contains('page-compare-vehicles') || document.querySelector('body').classList.contains('page-charging-calculator')) {
    // Next Step
    document.querySelectorAll('.next-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.nextElementSibling.classList.add('active')
      })
    })
    // Back Step
    document.querySelectorAll('.back-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.previousElementSibling.classList.add('active')
      })
    })
    // Indicative Fuel Cost
    function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
      let indicativeCost;
      if ($fuel_type === 'Electric' && $electric_range && $battery_size){
        let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
        let miles_per_kwh = $electric_range / $battery_size;
        let cost_per_mile = electricity_cost / miles_per_kwh;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type === 'Diesel' && $mpg) {
        let cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type !== false && $mpg) {
        let cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else {
        indicativeCost = 'N/A';
      }
      return indicativeCost;
    }
  }
  // Load Manufacturers Dropdown
  function loadManufacturersCalc() {
    var make_dropdowns = document.getElementsByName("calculator-make");
    for (i = 0; i < make_dropdowns.length; i++) {

      var dropdown = make_dropdowns[0];
      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Select Manufacturer';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      var url = '/api/car/manufacturers/ev';

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Models Dropdown
  function loadModelsCalc($type, $manufacturer, $ev = true, $inactive = false, $compare = false) {
    let model_dropdowns, derivative_dropdowns;
    ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;
      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Variant';
      defaultOption.value = '';
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
    }
    for (let i = 0; i < model_dropdowns.length; i++) {
      let dropdown = model_dropdowns[i];
      dropdown.length = 0;

      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Model';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let url;
      ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

      let params;
      ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        for (let x in data) {
          let option = document.createElement('option');
          option.text = data[x];
          option.value = x;
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Derivatives Dropdown
  function loadDerivativeCalc($type, $model, $default = false, $ev = true, $inactive = false, $compare = false, $hide_no_deal_ev = false) {
    let derivative_dropdowns;
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;

      if ($default){
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Variant';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
      }

      let url;
      ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model;

      let params;
      ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';
      // console.log(url + params)

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        // console.log(data)
        for (let x in data) {
          if (x === '2813'){ continue }
          let option = document.createElement('option');
          option.text = data[x];
          option.value = x;
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }

  // Journey Cost Calculator
  if (document.querySelector('body').classList.contains('page-journey-cost-calculator')) {
    loadManufacturersCalc();
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')
    let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
    let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
    let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
    let milesField = document.querySelector('input[name=journey-calculator-miles]')
    let electricityField = document.querySelector('input[name=journey-calculator-electricity]')
    let electricityLabel = document.querySelector('.electricity-cost-label')
    let makeText = document.querySelectorAll('.step-four-make')
    let modelText = document.querySelectorAll('.step-four-model')
    let stepOneNext = document.querySelector('#step-one-next')
    let stepTwoNext = document.querySelector('#step-two-next')
    let journey_distance, journey_cost, annual_journey_cost, co2, img_url, electric_range, battery_capacity;
    let comparable_london, comparable_ulez, comparable_journey_cost, comparable_annual_journey_cost, comparable_co2, comparable_img_url, comparable_mpg, comparable_type;
    let ev_loaded, ice_loaded = false;

    function loadVehicle($derivative, $ev = false) {
      let url = '/api/car/' + $derivative;
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        // console.log(data)
        let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : null;
        if ($ev) {
          // nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
          electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
          battery_capacity = data.car.battery_capacity;
          // miles_per_kWh = (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb')) ? getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (miles/kWh) - Comb').value : ( (getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb')) ? ( 100 / 1.609344 / parseFloat(getCapTechnicalData('Electric Vehicle Data', 'WLTP - EC (kWh/100km) - Comb').value)) : null);
          co2 = (data.car.co2) ? data.car.co2 : 0;
          img_url = data.car.main_img;
          // comparable_car = data.car.non_ev_comparable_car;
          // setTimeout(() => { loadVehicle(data.car.non_ev_comparable_car, false) }, 500);
          setTimeout(() => {
            if (electric_range && battery_capacity) {
              ev_loaded = true;
              document.getElementById('no-data').classList.add('visuallyhidden');
              (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
            } else {
              ev_loaded = false;
              stepOneNext.classList.add('disabled');
              document.getElementById('no-data').classList.remove('visuallyhidden');
            }
          }, 1000);
        } else {
          comparable_type = data.car.fuel_type;
          if (comparable_type === 'Electric') {
            setTimeout(() => {
              ice_loaded = false;
              stepOneNext.classList.add('disabled');
              document.getElementById('no-ice-two').classList.remove('visuallyhidden');
            }, 500);
          } else {
            // comparable_nox = ((getCapTechnicalData('Emissions - ICE', 'NOx') != null && isNaN(getCapTechnicalData('Emissions - ICE', 'NOx') != 'Not Available'))) ? 'Not Available': getCapTechnicalData('Emissions - ICE', 'NOx').value + 'mg';
            comparable_img_url = data.car.main_img;
            comparable_co2 = (data.car.co2) ? data.car.co2 : 0;
            comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
            if (comparable_type === 'Petrol') {
              comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
              comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? 12.50 : 0) : 0;
            } else if (comparable_type === 'Diesel') {
              comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
              comparable_ulez = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? 12.50 : 0) : 0;
            } else {
              comparable_london = (data.car.tax_band.london != null) ? data.car.tax_band.london : 0;
              comparable_ulez = 0;
            }
            setTimeout(() => {
              if (comparable_mpg && comparable_co2) {
                ice_loaded = true;
                document.getElementById('no-data-two').classList.add('visuallyhidden');
                document.getElementById('no-ice-two').classList.add('visuallyhidden');
                (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
              } else {
                ice_loaded = false;
                stepOneNext.classList.add('disabled');
                document.getElementById('no-data-two').classList.remove('visuallyhidden');
              }
            }, 1000);
          }
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }

    // First Step
    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
      (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
      derivativeField.classList.add('visuallyhidden')
      Array.prototype.slice.call(makeText, 0).forEach((value) => {
        value.innerHTML = makeField.options[makeField.selectedIndex].text
      })
      let buttonUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
      document.querySelector('.view-range-button').setAttribute('href', buttonUrl)

      document.getElementById('no-data').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')
    })
    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : null; // inactive reversed

      Array.prototype.slice.call(modelText, 0).forEach((value) => {
        value.innerHTML = modelField.options[modelField.selectedIndex].text
      })
      let buttonUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
      document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
      derivativeField.classList.remove('visuallyhidden')

      document.getElementById('no-data').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')

      setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 500);
    })
    derivativeField.addEventListener('change', () => {
      stepOneNext.classList.add('disabled');
      document.getElementById('no-data').classList.add('visuallyhidden');
      (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
    })

    // Second Step
    makeFieldCompare.addEventListener('change', () => {
      (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
      (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
      derivativeFieldCompare.classList.add('visuallyhidden')
      document.querySelector('.step-four-make-second').innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text;
      document.getElementById('no-data-two').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')
    })
    modelFieldCompare.addEventListener('change', () => {
      (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, false, false, true, true) : null;
      document.querySelector('.step-four-model-second').innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text;
      derivativeFieldCompare.classList.remove('visuallyhidden')

      document.getElementById('no-data-two').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')

      setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 500);
    })
    derivativeFieldCompare.addEventListener('change', () => {
      stepOneNext.classList.add('disabled');
      document.getElementById('no-data-two').classList.add('visuallyhidden');
      (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
    })

    // Third Step
    milesField.addEventListener('input', () => {
      (milesField.value > 0 && milesField.value <= 9999) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled')
    })
    document.querySelector('#route-button-auto').addEventListener('click', (e) => {
      document.querySelector('#route-button-auto').classList.remove('button-outline')
      document.querySelector('#route-button-manual').classList.add('button-outline')
      document.querySelector('.route-auto').classList.remove('visuallyhidden')
      document.querySelector('.route-manual').classList.add('visuallyhidden')
    })
    document.querySelector('#route-button-manual').addEventListener('click', (e) => {
      document.querySelector('#route-button-auto').classList.add('button-outline')
      document.querySelector('#route-button-manual').classList.remove('button-outline')
      document.querySelector('.route-auto').classList.add('visuallyhidden')
      document.querySelector('.route-manual').classList.remove('visuallyhidden')
    })

    // Fourth Step
    electricityField.addEventListener('input', () => {
      if(electricityField.value > 0 && electricityField.value <= 50){
        document.querySelector('#step-three-next').classList.remove('disabled')
      } else {
        document.querySelector('#step-three-next').classList.add('disabled')
      }
    })
    document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
      document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline')
      document.querySelector('#electricity-cost-button-manual').classList.add('button-outline')
      document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden')
      electricityField.classList.add('visuallyhidden')
      electricityLabel.classList.add('visuallyhidden')
      electricityField.value = document.querySelector('#electricity-cost').getAttribute('data-average')
      electricityField.dispatchEvent(new Event('input'))
    })
    document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
      document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
      document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
      document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
      electricityField.classList.remove('visuallyhidden')
      electricityLabel.classList.remove('visuallyhidden')
      electricityField.dispatchEvent(new Event('input'))
    })

    // Reset Form
    function resetForm() {
      document.getElementById('car-image').setAttribute('src', '/themes/evcarshop/img/placeholder.png');
      document.getElementById("journey-calculator-form").reset();
      derivativeField.classList.add('visuallyhidden')
      derivativeFieldCompare.classList.add('visuallyhidden')
      document.querySelectorAll('.journey-calculator-form > .step').forEach((value) => {
        value.classList.remove('active')
        value.classList.contains('step-one') ? value.classList.add('active') : null;
      })
      document.querySelectorAll('.next-step').forEach((value) => { value.classList.add('disabled') })
      document.getElementById('journey-calculator-route-text').innerText = '';
    }
    setTimeout(resetForm, 500);
    document.querySelectorAll('.start-again').forEach((value) => {
      value.addEventListener('click', resetForm)
    })

    // Calculate
    document.querySelector('#step-three-next').addEventListener('click', (e) => {
      let journey_frequency = document.querySelector('input[name="frequency"]:checked').value;
      let london_frequency = document.querySelector('input[name="london"]:checked').value;
      let ulez_frequency = document.querySelector('input[name="ulez"]:checked').value;
      let pence_per_kwh = electricityField.value;
      journey_distance = milesField.value;

      // First Car
      document.getElementById('car-image').setAttribute('src', img_url);
      document.getElementById('summary-co2').innerText = co2 + 'g/km';
      // document.getElementById('summary-nox').innerText = nox;

      let indicative_fuel_cost = indicativeCost('Electric', null, electric_range, battery_capacity, pence_per_kwh)
      document.getElementById('summary-per-mile').innerText = parseFloat(indicative_fuel_cost).toFixed(1) + 'p'

      journey_cost = (journey_distance * indicative_fuel_cost) / 100; // journey cost (pound)
      document.getElementById('summary-journey').innerText = '£' + journey_cost.toFixed(2);

      annual_journey_cost = journey_frequency * journey_cost;
      document.getElementById('summary-annual').innerText = '£' + annual_journey_cost.toFixed(2)
      document.getElementById('summary-monthly').innerText = '£' + (annual_journey_cost/12).toFixed(2)

      // Second Car
      document.getElementById('car-image-second').setAttribute('src', comparable_img_url);
      document.getElementById('summary-co2-second').innerText = comparable_co2 + 'g/km';
      // document.getElementById('summary-nox-second').innerText = comparable_nox;

      let comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, false, false, pence_per_kwh);
      document.getElementById('summary-per-mile-second').innerText = parseFloat(comparable_indicative_fuel_cost).toFixed(1) + 'p';

      comparable_journey_cost = (journey_distance * comparable_indicative_fuel_cost) / 100; // journey cost (pound)
      document.getElementById('summary-journey-second').innerText = '£' + comparable_journey_cost.toFixed(2);

      comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
      document.getElementById('summary-annual-second').innerText = '£' + comparable_annual_journey_cost.toFixed(2)
      document.getElementById('summary-monthly-second').innerText = '£' + (comparable_annual_journey_cost/12).toFixed(2)

      document.getElementById('summary-london-daily-second').innerText = '£' + ((london_frequency == 0) ? 0 : comparable_london);
      document.getElementById('summary-ulez-daily-second').innerText = '£' + ((ulez_frequency == 0) ? 0 : comparable_ulez).toFixed(2);
      document.getElementById('summary-london-annual-second').innerText = '£' + (london_frequency * comparable_london);
      document.getElementById('summary-ulez-annual-second').innerText = '£' + (ulez_frequency * comparable_ulez).toFixed(2);
      // let comparable_journey_cost = (journey_distance * comparable_indicative_cost) / 100; // journey cost (pound)
      // let comparable_annual_journey_cost = journey_frequency * comparable_journey_cost;
      // let comparable_three_year_saving = (comparable_annual_journey_cost - annual_journey_cost) * 3;
      // document.getElementById('summary-estimated-saving').innerText = '£' + comparable_three_year_saving.toFixed(0)

      let total_journey_saving = ((comparable_journey_cost - journey_cost) + ((london_frequency == 0) ? 0 : comparable_london) + ((ulez_frequency == 0) ? 0 : comparable_ulez));
      let total_annual_saving = (total_journey_saving * journey_frequency);
      let total_co2_saving = (comparable_co2 * journey_frequency) + 'g/km';
      // let total_three_year_saving = (((comparable_journey_cost - journey_cost) * journey_frequency) * 3);

      document.getElementById('summary-savings-total').innerText = '£' + total_journey_saving.toFixed(2);
      document.getElementById('summary-savings-annual').innerText = '£' + total_annual_saving.toFixed(2);
      document.getElementById('summary-savings-co2').innerText = total_co2_saving;
      // document.getElementById('summary-estimated-saving').innerText = '£' + total_three_year_saving.toFixed(2);
    })
  }

  // Charging Time & Cost Calculator
  if (document.querySelector('body').classList.contains('page-charging-calculator')) {
    loadManufacturersCalc();
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')
    let electricityField = document.querySelector('input[name=charging-calculator-electricity]')
    let electricityLabel = document.querySelector('.electricity-cost-label')
    let rateSwitch = document.querySelectorAll('input[name=speed]')
    let stepOneNext = document.querySelector('#step-one-next')
    let slider = document.getElementById('chargePercentage');
    let output = document.getElementById('chargePercentageNumber');
    let button_url, electric_range, averageValue, charger_speed, charging_time, slow_kw, fast_kw, rapid_kw, slow_time, fast_time, rapid_time, img_url, charger_rate, battery_capacity;

    function loadVehicle($derivative) {
      let url = '/api/car/' + $derivative;
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        // console.log(data)
        let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
        img_url = data.car.main_img;
        battery_capacity = data.car.battery_capacity;
        electric_range = (data.car.electric_range != null) ? data.car.electric_range : ((data.car.technical) ? ((getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)')) ? parseFloat(getCapTechnicalData('Electric Vehicle Data', 'Electric Range (miles)').value) : null) : null);
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW')) ? slow_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow kW').value : slow_kw = null;
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW')) ? fast_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast kW').value : fast_kw = null;
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time')) ? slow_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Slow Time').value : slow_time = null;
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time')) ? fast_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Fast Time').value : fast_time = null;
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW')) ? rapid_kw = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid kW').value : rapid_kw = null;
        // (getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time')) ? rapid_time = getCapTechnicalData('Electric Vehicle Data', 'Battery Charge Rapid Time').value : rapid_time = null;
        slow_kw = 7;
        fast_kw = 50;
        rapid_kw = 150;
        slow_time = (battery_capacity / slow_kw)*60;
        fast_time = (battery_capacity / fast_kw)*60;
        rapid_time = (battery_capacity / rapid_kw)*60;

        setTimeout(() => {
          if (electric_range && slow_kw && battery_capacity && slow_time) {
            document.getElementById('car-image').setAttribute('src', img_url);
            document.getElementById('no-data').classList.add('visuallyhidden');
            document.getElementById('speed-slow').setAttribute('value', slow_kw);
            document.querySelector('#speed-slow-label > span').innerText = slow_kw;
            (derivativeField.childElementCount > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
            button_url = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
            document.querySelector('.view-range-button').setAttribute('href', button_url)

            Array.prototype.slice.call(document.querySelectorAll('.step-four-make'), 0).forEach((value) => {
              value.innerHTML = makeField.options[makeField.selectedIndex].text
            })
            Array.prototype.slice.call(document.querySelectorAll('.step-four-model'), 0).forEach((value) => {
              value.innerHTML = modelField.options[modelField.selectedIndex].text
            })

            if (fast_kw && fast_time && parseFloat(fast_time) > 1 && parseFloat(fast_kw) > 1) {
              document.getElementById('speed-fast-label').style.display = 'block';
              document.getElementById('speed-fast').setAttribute('value', fast_kw);
              document.querySelector('#speed-fast-label > span').innerText = fast_kw;
            } else {
              document.getElementById('speed-fast-label').style.display = 'none';
            }
            if (rapid_kw && rapid_time && parseFloat(rapid_time) > 1 && parseFloat(rapid_kw) > 1) {
              document.getElementById('speed-rapid-label').style.display = 'block';
              document.getElementById('speed-rapid').setAttribute('value', rapid_kw);
              document.querySelector('#speed-rapid-label > span').innerText = rapid_kw;
            } else {
              document.getElementById('speed-rapid-label').style.display = 'none';
            }
          } else {
            document.getElementById('no-data').classList.remove('visuallyhidden');
          }
        }, 1000);

      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }

    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : false;
      (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
      derivativeField.classList.add('visuallyhidden')

      document.getElementById('no-data').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')
    })

    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : false; // inactive reversed

      derivativeField.classList.remove('visuallyhidden')

      document.getElementById('no-data').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')

      setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false }, 500);
    })

    derivativeField.addEventListener('change', () => {
      stepOneNext.classList.add('disabled');
      document.getElementById('no-data').classList.add('visuallyhidden');
      (derivativeField.value > 0) ? loadVehicle(derivativeField.value) : false;
    })

    electricityField.addEventListener('input', () => {
      if(electricityField.value > 0 && electricityField.value <= 50){
        document.querySelector('#step-three-next').classList.remove('disabled')
      } else {
        document.querySelector('#step-three-next').classList.add('disabled')
      }
    })

    document.querySelector('#electricity-cost-button-auto').addEventListener('click', (e) => {
      document.querySelector('#electricity-cost-button-auto').classList.remove('button-outline');
      document.querySelector('#electricity-cost-button-manual').classList.add('button-outline');
      document.querySelector('#electricity-cost-average').classList.remove('visuallyhidden');
      (charger_rate == '150') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-ultra') : ( (charger_rate == '50') ? averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity-rapid') : averageValue = document.querySelector('#average-data').getAttribute('data-average-electricity') );
      document.querySelector('#electricity-cost-average span').innerHTML = averageValue;
      document.querySelector('#electricity-cost').setAttribute('data-average', averageValue);
      electricityField.classList.add('visuallyhidden')
      electricityLabel.classList.add('visuallyhidden')
      electricityField.value = averageValue
      electricityField.dispatchEvent(new Event('input'))
    })

    document.querySelector('#electricity-cost-button-manual').addEventListener('click', (e) => {
      document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
      document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
      document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
      electricityField.classList.remove('visuallyhidden')
      electricityLabel.classList.remove('visuallyhidden')
      electricityField.dispatchEvent(new Event('input'))
    })

    // Calculate
    function calculate($percentage, $charger_rate, $electricity_cost, $electric_range, $battery_capacity, $charging_time) {
      function percentage(num, per){ return (num/100)*per }
      let indicative_cost = indicativeCost('Electric', null, $electric_range, $battery_capacity, $electricity_cost);
      let charge_cost = (parseFloat(indicative_cost) * parseFloat(percentage($electric_range, $percentage)))/100;
      document.getElementById('summary-miles').innerText = parseFloat(percentage($electric_range, $percentage)).toFixed(1) + ' miles';
      document.getElementById('summary-estimate').innerText = parseFloat(indicative_cost).toFixed(1) + 'p';
      document.getElementById('summary-cost').innerText = '£' + charge_cost.toFixed(2);
      document.getElementById('summary-time').innerText = (parseFloat(percentage($charging_time, $percentage))/60 < 1) ? parseFloat(percentage($charging_time, $percentage)).toFixed(0) + 'min' : (parseFloat(percentage($charging_time, $percentage))/60).toFixed(1) + 'h';
      document.getElementById('summary-kwh').innerText = parseFloat(percentage($battery_capacity, $percentage)).toFixed(0) + 'kWh';
    }

    rateSwitch.forEach((value) => {
      value.addEventListener('change', (e) => {
        charger_rate = e.target.value;
        (e.target.dataset.speed === 'fast') ? charging_time = fast_time : ((e.target.dataset.speed === 'slow') ? charging_time = slow_time : charging_time = rapid_time);
        document.querySelector('#step-two-next').classList.remove('disabled');
      })
    })

    document.querySelector('#step-three-next').addEventListener('click', (e) => {
      calculate(slider.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
    })

    output.innerHTML = slider.value;
    slider.oninput = function() {
      output.innerHTML = this.value
      calculate(this.value, charger_rate, electricityField.value, electric_range, battery_capacity, charging_time)
    }

    // Reset Form
    function resetForm() {
      document.getElementById('car-image').setAttribute('src', '/themes/evcarshop/img/placeholder.png');
      document.getElementById("charging-calculator-form").reset();
      derivativeField.classList.add('visuallyhidden');
      document.querySelectorAll('.charging-calculator-form > .step').forEach((value) => {
        value.classList.remove('active')
        value.classList.contains('step-one') ? value.classList.add('active') : false;
      })
      document.querySelectorAll('.next-step').forEach((value) => { value.classList.add('disabled') })

      document.querySelector('#electricity-cost-button-auto').classList.add('button-outline')
      document.querySelector('#electricity-cost-button-manual').classList.remove('button-outline')
      document.querySelector('#electricity-cost-average').classList.add('visuallyhidden')
      electricityField.classList.remove('visuallyhidden')
      electricityLabel.classList.remove('visuallyhidden')
    }
    setTimeout(resetForm, 500);
    document.querySelectorAll('.start-again').forEach((value) => {
      value.addEventListener('click', resetForm);
    })
  }

  // Tax Calculator
  if (document.querySelector('body').classList.contains('page-tax-calculator')) {
    loadManufacturersCalc();
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')
    let makeFieldCompare = document.querySelector('select[name=calculator-make-compare]')
    let modelFieldCompare = document.querySelector('select[name=calculator-model-compare]')
    let derivativeFieldCompare = document.querySelector('select[name=calculator-derivative-compare]')
    let stepOneNext = document.querySelector('#step-one-next')
    let stepTwoNext = document.querySelector('#step-two-next')
    let tax_band = 20;
    let ev_loaded, ice_loaded = false;
    let fuel_type, img_url, p11d, bik1, bik2, bik3, indicative_fuel_cost, co2;
    let comparable_value, comparable_type, comparable_img_url, comparable_mpg, comparable_p11d, comparable_bik1, comparable_bik2, comparable_bik3, comparable_indicative_fuel_cost, comparable_co2;

    function loadVehicle($derivative, $ev = false) {
      let url = '/api/car/' + $derivative;
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        // console.log(data)
        if ($ev) {
          co2 = (data.car.co2) ? data.car.co2 : null;
          bik1 = (data.car.tax) ? data.car.tax.Year1 : null;
          bik2 = (data.car.tax) ? data.car.tax.Year2 : null;
          bik3 = (data.car.tax) ? data.car.tax.Year3 : null;
          p11d = (data.car.base_price) ? data.car.base_price : null;
          img_url = (data.car.main_img) ? data.car.main_img : null;
          fuel_type = (data.car.fuel_type) ? data.car.fuel_type : null;
          // ved_first = data.car.tax_band.rate;
          // ved_annual = data.car.tax_band.second_rate;
          indicative_fuel_cost = indicativeCost(fuel_type, null, (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
          setTimeout(() => {
            if (co2 && img_url && fuel_type && bik1 != null && data.car.electric_range && data.car.battery_capacity) {
              ev_loaded = true;
              document.getElementById('no-data').classList.add('visuallyhidden');
              (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ice_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
            } else {
              ev_loaded = false;
              document.getElementById('no-data').classList.remove('visuallyhidden');
            }
          }, 1000);
        } else {
          comparable_type = data.car.fuel_type;
          if (comparable_type === 'Electric') {
            setTimeout(() => {
              ice_loaded = false;
              stepOneNext.classList.add('disabled');
              document.getElementById('no-ice-two').classList.remove('visuallyhidden');
            }, 500);
          } else {
            comparable_co2 = data.car.co2;
            comparable_img_url = data.car.main_img;
            comparable_p11d = data.car.base_price;
            // comparable_ved_first = data.car.tax_band.rate;
            // comparable_ved_annual = data.car.tax_band.second_rate;
            comparable_value = data.car.base_price;
            comparable_bik1 = data.car.tax.Year1;
            comparable_bik2 = data.car.tax.Year2;
            comparable_bik3 = data.car.tax.Year3;
            comparable_mpg = (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra);
            comparable_indicative_fuel_cost = indicativeCost(comparable_type, comparable_mpg, null, null);
            setTimeout(() => {
              if (comparable_value && comparable_bik1 != null && comparable_mpg && comparable_co2) {
                ice_loaded = true;
                document.getElementById('no-data-two').classList.add('visuallyhidden');
                document.getElementById('no-ice-two').classList.add('visuallyhidden');
                (derivativeField.childElementCount > 0 && derivativeFieldCompare.childElementCount > 0 && ev_loaded) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled');
              } else {
                ice_loaded = false;
                document.getElementById('no-data-two').classList.remove('visuallyhidden');
              }
            }, 1000);
          }
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }

    // First Step
    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value) : null;
      (modelField.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
      Array.prototype.slice.call(document.querySelectorAll('.step-three-make'), 0).forEach((value) => {
        value.innerHTML = makeField.options[makeField.selectedIndex].text
      })
      derivativeField.classList.add('visuallyhidden')
      let buttonUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
      document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
    })
    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, false, true, true, false) : null; // inactive reversed
      Array.prototype.slice.call(document.querySelectorAll('.step-three-model'), 0).forEach((value) => {
        value.innerHTML = modelField.options[modelField.selectedIndex].text
      })
      let buttonUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase()
      document.querySelector('.view-range-button').setAttribute('href', buttonUrl)
      derivativeField.classList.remove('visuallyhidden')

      document.getElementById('no-data').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')

      setTimeout(() => { (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null }, 500);
    })
    derivativeField.addEventListener('change', () => {
      stepOneNext.classList.add('disabled');
      document.getElementById('no-data').classList.add('visuallyhidden');
      (derivativeField.value > 0) ? loadVehicle(derivativeField.value, true) : null;
    })

    // Second Step
    makeFieldCompare.addEventListener('change', () => {
      (makeFieldCompare.value > 0) ? loadModelsCalc('car', makeFieldCompare.value, false, false, true) : null;
      (modelFieldCompare.value > 0) ? stepOneNext.classList.remove('disabled') : stepOneNext.classList.add('disabled')
      derivativeFieldCompare.classList.add('visuallyhidden')
      document.querySelector('.step-four-make-second').innerHTML = makeFieldCompare.options[makeFieldCompare.selectedIndex].text;
      document.getElementById('no-data-two').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')
    })
    modelFieldCompare.addEventListener('change', () => {
      (modelFieldCompare.value > 0) ? loadDerivativeCalc('car', modelFieldCompare.value, false, false, true, true) : null;
      document.querySelector('.step-four-model-second').innerHTML = modelFieldCompare.options[modelFieldCompare.selectedIndex].text;
      derivativeFieldCompare.classList.remove('visuallyhidden')

      document.getElementById('no-data-two').classList.add('visuallyhidden')
      stepOneNext.classList.add('disabled')

      setTimeout(() => { (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null }, 500);
    })
    derivativeFieldCompare.addEventListener('change', () => {
      stepOneNext.classList.add('disabled');
      document.getElementById('no-data-two').classList.add('visuallyhidden');
      (derivativeFieldCompare.value > 0) ? loadVehicle(derivativeFieldCompare.value) : null;
    })

    // Third Step - Company Switch
    // document.querySelectorAll('input[name=company]').forEach((value) => {
    //   value.addEventListener('change', (e) => {
    //     (e.target.value === 'yes') ? company_car = true : company_car = false;
    //     (e.target.value === 'yes') ? tax_band = 20 : tax_band = 0;
    //     (e.target.value === 'yes') ? taxBand.classList.remove('visuallyhidden') : taxBand.classList.add('visuallyhidden');
    //     (e.target.value === 'yes') ? stepThreeNext.classList.add('disabled') : stepThreeNext.classList.remove('disabled')
    //   })
    // })

    // Third Step - Tax Band Switch
    document.querySelector('select[name=calculator-tax-band]').addEventListener('change', (e) => {
      // (e.target.value > 0) ? stepTwoNext.classList.remove('disabled') : stepTwoNext.classList.add('disabled');
      (e.target.value === '20') ? tax_band = 20 : tax_band = 40;
      document.querySelectorAll('.tax-payable').forEach((value => {value.innerHTML = e.target.value}))
    })

    // Fourth Step - Frequency Switch
    // document.querySelectorAll('input[name=frequency]').forEach((value) => {
    //   value.addEventListener('change', (e) => {
    //     congestion_charge_freq = e.target.value
    //   })
    // })

    function calculateBIK($p11d, $bik_rate) {
      return ($p11d * ($bik_rate / 100));
    }
    function calculateTAX($p11d, $bik_rate, $tax_rate = 0) {
      return ($p11d * ($bik_rate / 100)) * ($tax_rate / 100);
    }
    // function calculateNIC($p11d, $bik_rate, $nic_rate = 13.80) {
    //   return ($p11d * ($bik_rate / 100)) * ($nic_rate / 100);
    // }

    // Calculate
    stepTwoNext.addEventListener('click', (e) => {
      // let ved_total = (ved_first + (2 * ved_annual));
      let bik_total = (calculateBIK(p11d, bik1, tax_band) + calculateBIK(p11d, bik2, tax_band) + calculateBIK(p11d, bik3, tax_band)).toFixed(0);
      let tax_total = (calculateTAX(p11d, bik1, tax_band) + calculateTAX(p11d, bik2, tax_band) + calculateTAX(p11d, bik3, tax_band)).toFixed(0);
      document.getElementById('car-image').setAttribute('src', img_url)
      document.getElementById('summary-type').innerText = fuel_type
      // document.getElementById('summary-ved-first').innerText = '£' + ved_first
      // document.getElementById('summary-ved-annual').innerText = '£' + ved_annual
      // document.getElementById('summary-ved-total').innerText = '£' + ved_total
      document.getElementById('summary-p11d').innerText = '£' + (p11d)
      document.getElementById('summary-co2').innerText = (co2) + 'g/km'
      document.getElementById('summary-bik1').innerText = '£' + (calculateBIK(p11d, bik1)).toFixed(0)
      document.getElementById('summary-bik2').innerText = '£' + (calculateBIK(p11d, bik2)).toFixed(0)
      document.getElementById('summary-bik3').innerText = '£' + (calculateBIK(p11d, bik3)).toFixed(0)
      document.getElementById('summary-bik1tax').innerText = '£' + (calculateTAX(p11d, bik1, tax_band)).toFixed(0)
      document.getElementById('summary-bik2tax').innerText = '£' + (calculateTAX(p11d, bik2, tax_band)).toFixed(0)
      document.getElementById('summary-bik3tax').innerText = '£' + (calculateTAX(p11d, bik3, tax_band)).toFixed(0)
      document.getElementById('summary-bik1rate').innerText = (bik1) + '%'
      document.getElementById('summary-bik2rate').innerText = (bik2) + '%'
      document.getElementById('summary-bik3rate').innerText = (bik3) + '%'
      // document.getElementById('summary-bik4').innerText = '£' + bik_total
      document.getElementById('summary-fuel').innerText = (indicative_fuel_cost) + 'p/mile'

      // let comparable_ved_total = (comparable_ved_first + (2 * comparable_ved_annual));
      let comparable_bik_total = (calculateBIK(comparable_p11d, comparable_bik1, tax_band) + calculateBIK(comparable_p11d, comparable_bik2, tax_band) + calculateBIK(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);
      let comparable_tax_total = (calculateTAX(comparable_p11d, comparable_bik1, tax_band) + calculateTAX(comparable_p11d, comparable_bik2, tax_band) + calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0);
      document.getElementById('car-image-second').setAttribute('src', comparable_img_url)
      document.getElementById('summary-type-second').innerText = comparable_type
      // document.getElementById('summary-ved-first-second').innerText = '£' + comparable_ved_first
      // document.getElementById('summary-ved-annual-second').innerText = '£' + comparable_ved_annual
      // document.getElementById('summary-ved-total-second').innerText = '£' + comparable_ved_total
      document.getElementById('summary-p11d-second').innerText = '£' + (comparable_p11d)
      document.getElementById('summary-co2-second').innerText = (comparable_co2) + 'g/km'
      document.getElementById('summary-bik1-second').innerText = '£' + (calculateBIK(comparable_p11d, comparable_bik1)).toFixed(0)
      document.getElementById('summary-bik2-second').innerText = '£' + (calculateBIK(comparable_p11d, comparable_bik2)).toFixed(0)
      document.getElementById('summary-bik3-second').innerText = '£' + (calculateBIK(comparable_p11d, comparable_bik3)).toFixed(0)
      document.getElementById('summary-bik1tax-second').innerText = '£' + (calculateTAX(comparable_p11d, comparable_bik1, tax_band)).toFixed(0)
      document.getElementById('summary-bik2tax-second').innerText = '£' + (calculateTAX(comparable_p11d, comparable_bik2, tax_band)).toFixed(0)
      document.getElementById('summary-bik3tax-second').innerText = '£' + (calculateTAX(comparable_p11d, comparable_bik3, tax_band)).toFixed(0)
      document.getElementById('summary-bik1rate-second').innerText = (comparable_bik1) + '%'
      document.getElementById('summary-bik2rate-second').innerText = (comparable_bik2) + '%'
      document.getElementById('summary-bik3rate-second').innerText = (comparable_bik3) + '%'
      // document.getElementById('summary-bik4-second').innerText = '£' + comparable_bik_total
      document.getElementById('summary-fuel-second').innerText = (comparable_indicative_fuel_cost) + 'p/mile'

      document.getElementById('summary-total-tax').innerText = '£' + (tax_total);
      document.getElementById('summary-total-tax-second').innerText = '£' + (comparable_tax_total);
      document.getElementById('summary-total-savings').innerText = '£' + ((parseFloat(comparable_tax_total)) - (parseFloat(tax_total)));

      // let comparable_tax_amount;
      // let comparable_bik_rate = (comparable_bik / 100) * comparable_value;
      // (tax_band === 0) ? comparable_tax_amount = comparable_bik_rate : comparable_tax_amount = (tax_band / 100) * comparable_bik_rate;
      // document.getElementById('summary-total-tax').innerText = '£' + (ved_total + ((fuel_type === 'Electric') ? 0 : ((congestion_charge * congestion_charge_freq) * 3)))
      // document.getElementById('summary-total-savings').innerText = '£' + ((fuel_type !== 'Electric') ? 0 : (((parseFloat(congestion_charge) * parseFloat(congestion_charge_freq)) + parseFloat(comparable_tax_amount)) * 3)).toFixed(0)
    })

    // Reset Form
    function resetForm() {
      document.getElementById('car-image').setAttribute('src', '/themes/evcarshop/img/placeholder.png');
      stepOneNext.classList.add('disabled')
      derivativeField.classList.add('visuallyhidden')
      derivativeFieldCompare.classList.add('visuallyhidden')
      document.getElementById("tax-calculator-form").reset()
      document.querySelectorAll('.tax-calculator-form > .step').forEach((value) => {
        value.classList.remove('active')
        value.classList.contains('step-one') ? value.classList.add('active') : null
      })
    }
    setTimeout(resetForm, 500);
    document.querySelectorAll('.start-again').forEach((value) => {
      value.addEventListener('click', resetForm)
    })

  }

  // Compare Vehicles
  if (document.querySelector('body').classList.contains('page-compare-vehicles')) {
    let comparisonTable = document.getElementById('car-comparison')
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')

    function compareColumns(row, reverse = false, blue = false) {
      let largest = 0
      let smallest = 9999
      comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
        if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
          (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
          (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
          comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
          if(largest !== smallest) {
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
          }
        }
      })
    }

    function loadVehicle($spot, $derivative) {
      if ($derivative !== 0) {
        let url = '/api/car/' + $derivative;
        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
          ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');
          comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .derivative`).innerText = data.car.name;
          (data.car.active == '1' && data.car.fuel_type == 'Electric') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
          comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

          comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + (parseFloat(data.car.base_price)).toFixed(0) : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min')) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
          (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min')) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
          compareColumns('electric-range');
          comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
          (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
          compareColumns('real-electric-range');

          comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
          (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
          compareColumns('official-mpg');
          comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
          (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
          compareColumns('real-mpg');

          let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
          comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
          (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
          compareColumns('indicative-cost', true);

          // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
          comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? data.car.co2 + ' g/km' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

          if (data.car.tax_band) {
            comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
            (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
            compareColumns('first-year-rate', true);
            comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
            (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
            compareColumns('year-rate', true);
          }

          if (data.car.fuel_type === 'Petrol') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Diesel') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Electric') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          } else {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          }

          if (data.car.tax) {
            comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
            (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
            compareColumns('bik-1', true);
            comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
            (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
            compareColumns('bik-2', true);
            comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
            (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
            compareColumns('bik-3', true);
          }

          comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats')) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
          (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
          compareColumns('engine-size', false, true);
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
          comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP')) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
          (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
          compareColumns('engine-power', false, true);
          comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
          (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
          compareColumns('acceleration', false, true);
          comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed')) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
          (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
          compareColumns('top-speed', false, true);
          if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
            for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
              let star = document.createElement("img");
              star.setAttribute('src', '/themes/evcarshop/img/icons/general/star-gold.svg');
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
            }
          } else {
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          }
          comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group')) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

          (data.car.active == '1' && data.car.fuel_type == 'Electric') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

          loadModelsCalc('car', 0, false, true)
          comparisonTable.reset();
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }

    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, true) : false;
    })

    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, true, false, true) : false;
    })

    derivativeField.addEventListener('change', (event) => {
      if(event.target.value > 0) {
        if(parseInt(comparisonTable.dataset.carFirst) < 1) {
          loadVehicle('first', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
          loadVehicle('second', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
          loadVehicle('third', event.target.value)
        } else { }
      }
    })

    function resetSlot($slot) {
      comparisonTable.setAttribute('data-car-form', '1');
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
      if ($slot === 'first') {
        comparisonTable.setAttribute('data-car-first', '-1');
      } else if ($slot === 'second') {
        comparisonTable.setAttribute('data-car-second', '-1');
      } else {
        comparisonTable.setAttribute('data-car-third', '-1');
      }

      let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
      [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
        if (index === 0) {
          (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
          (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
          (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
        }
      })
    }
    document.querySelectorAll('.car-comparison-table-row--img>div[data-car] .reset').forEach(value => {
      value.addEventListener('click', evt => {
        comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
        (evt.target.classList.contains('first')) ? resetSlot('first') : null;
        (evt.target.classList.contains('second')) ? resetSlot('second') : null;
        (evt.target.classList.contains('third')) ? resetSlot('third') : null;
      })
    })

  }

  // Gauges
  if (document.querySelector('#charging-speeds')) {
    const gaugeOpts = {
      angle: -0.25, lineWidth: 0.18, radiusScale: 1, strokeColor: '#F2F3F3',
      generateGradient: true, highDpiSupport: true,
      pointer: { length: 0.58, strokeWidth: 0.04, color: '#2C363A' }
    }
    const gaugeHomeOpts = { colorStart: '#EEE354', colorStop: '#EBCF00'};
    const gaugeFastOpts = { colorStart: '#32E1CF', colorStop: '#32DDE1' };
    const gaugeRapidOpts = { colorStart: '#32E1C3', colorStop: '#32E18A' };

    function runGauge($target, $opts, $animationSpeed, $maxValue) {
      if ($target){
        let gauge = new Gauge($target).setOptions({...gaugeOpts, ...$opts});
        gauge.maxValue = $maxValue;
        gauge.setMinValue(0);
        gauge.animationSpeed = $animationSpeed;
        gauge.set(($maxValue - $target.dataset.minutes));
      }
    }

    let chargingSpeedsSection = document.getElementById('charging-speeds').getBoundingClientRect();
    let offsetToTriggerAnimation = chargingSpeedsSection.y + (chargingSpeedsSection.height/4);
    function scrollAnimTriggerCheck(e) {
      let viewBottom = window.scrollY + window.innerHeight;
      if (viewBottom > offsetToTriggerAnimation) {
        runGauge(document.getElementById('gaugeHome'), gaugeHomeOpts, 400, 1440);
        runGauge(document.getElementById('gaugeFast'), gaugeFastOpts, 300, 1440);
        runGauge(document.getElementById('gaugeRapid'), gaugeRapidOpts, 200, 1440);
        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }

  // Request Charger Strip
  if (document.querySelector('#request-charger-strip')) {
    if (document.querySelector('#request-charger-strip').dataset.type === 'home'){
      let makeField = document.querySelector('select[name=charger-make]')
      let modelField = document.querySelector('select[name=charger-model]')
      let urlParking, urlMake, urlModel = 'undefined';

      // Load Models Dropdown
      function loadModelsCharger($type, $manufacturer) {
        let model_dropdowns = document.getElementsByName("charger-model");
        for (let i = 0; i < model_dropdowns.length; i++) {
          let dropdown = model_dropdowns[i];
          dropdown.length = 0;

          let defaultOption = document.createElement('option');
          defaultOption.text = 'Select Model';
          defaultOption.value = '';

          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;

          let url = '/api/' + $type + '/models/' + $manufacturer + '/ev';

          fetch(url).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            for (let x in data) {
              let option = document.createElement('option');
              option.text = data[x];
              option.value = x;
              dropdown.add(option);
            }
          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }
      }

      makeField.addEventListener('change', () => {
        (makeField.value > 0) ? loadModelsCharger('car', makeField.value) : loadModelsCharger('car', 0);
        (makeField.value > 0) ? document.querySelector('input[name=charger-dont-know]').checked = false : document.querySelector('input[name=charger-dont-know]').checked = true;
        (makeField.value > 0) ? document.querySelector('.vehicle-switch .checkbox').style.pointerEvents = 'all' : document.querySelector('.vehicle-switch .checkbox').style.pointerEvents = 'none';
        urlMake = makeField.options[makeField.selectedIndex].text;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=home&parking=' + urlParking + '&make=' + encodeURIComponent(urlMake) + '&model=' + encodeURIComponent(urlModel))
      })

      modelField.addEventListener('change', () => {
        urlModel = modelField.options[modelField.selectedIndex].text;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=home&parking=' + urlParking + '&make=' + encodeURIComponent(urlMake) + '&model=' + encodeURIComponent(urlModel))
      })

      document.querySelector('#quote-form-parking').addEventListener('change', (e) => {
        urlParking = e.target.value;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=home&parking=' + urlParking + '&make=' + encodeURIComponent(urlMake) + '&model=' + encodeURIComponent(urlModel))
      })

      document.querySelector('input[name=charger-dont-know]').addEventListener('change', (e) => {
        if (e.target.checked) {
          document.querySelector('.vehicle-switch .checkbox').style.pointerEvents = 'none'
          urlMake = 'undefined'
          urlModel = 'undefined'
          makeField.selectedIndex = 0
          modelField.selectedIndex = 0
          document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=home&parking=' + urlParking + '&make=undefined&model=undefined');
        } else {
          document.querySelector('.vehicle-switch .checkbox').style.pointerEvents = 'all'
        }
      })

    } else if (document.querySelector('#request-charger-strip').dataset.type === 'work') {
      let urlParking, urlSpeed, urlQuantity = 'undefined';

      document.querySelector('#quote-form-speed').addEventListener('change', (e) => {
        urlSpeed = e.target.value;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=workplace&parking=' + urlParking + '&speed=' + urlSpeed + '&quantity=' + urlQuantity)
      })

      document.querySelector('#quote-form-parking').addEventListener('change', (e) => {
        urlParking = e.target.value;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=workplace&parking=' + urlParking + '&speed=' + urlSpeed + '&quantity=' + urlQuantity)
      })

      document.querySelector('#quote-form-quantity').addEventListener('change', (e) => {
        urlQuantity = e.target.value;
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=workplace&parking=' + urlParking + '&speed=' + urlSpeed + '&quantity=' + urlQuantity)
      })

    } else if (document.querySelector('#request-charger-strip').dataset.type === 'consultancy') {
      let consultancyUrl = new URL(window.location.origin + '/consultancy-enquiry');
      consultancyUrl.searchParams.append("type", "business");
      consultancyUrl.searchParams.append("ev", "no");
      consultancyUrl.searchParams.append("charging", "no");
      consultancyUrl.searchParams.append("fleet", "no");
      document.getElementById('charger-quote-enquiry-button').setAttribute('href', consultancyUrl.href)

      function resetQuoteForm() {
        document.getElementById('consultancy-strip-form').reset();
      }
      setTimeout(resetQuoteForm, 500);

      document.querySelectorAll('#quote-form-type input').forEach((value) => {
        value.addEventListener('change', (e) => {
          consultancyUrl.searchParams.set("type", e.target.value);
          document.getElementById('charger-quote-enquiry-button').setAttribute('href', consultancyUrl.href)
        })
      })

      document.querySelector('#advice-switch-ev').addEventListener('change', (e) => {
        consultancyUrl.searchParams.set("ev", (e.target.checked ? 'yes' : 'no'));
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', consultancyUrl.href)
      })

      document.querySelector('#advice-switch-charging').addEventListener('change', (e) => {
        consultancyUrl.searchParams.set("charging", (e.target.checked ? 'yes' : 'no'));
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', consultancyUrl.href)
      })

      document.querySelector('#advice-switch-fleet').addEventListener('change', (e) => {
        consultancyUrl.searchParams.set("fleet", (e.target.checked ? 'yes' : 'no'));
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', consultancyUrl.href)
      })

    } else {
      document.querySelector('#quote-form-charger').addEventListener('change', (e) => {
        document.getElementById('charger-quote-enquiry-button').setAttribute('href', '/charger-quote-enquiry?type=' + e.target.value)
      })
    }
  }

  // Deal Finder Strip
  if (document.querySelector('#deal-finder-strip')) { // TODO: DRY it out
    let typeSwitch = document.querySelectorAll('#deal-finder-category input');
    let chargerSwitch = document.querySelectorAll('#deal-finder-charger input');
    let typeSections = document.querySelectorAll('.deal-finder-container > section');

    let makeField = document.querySelector('select[name=deal-finder-make]');
    let modelField = document.querySelector('select[name=deal-finder-model]');
    let carUrl = '/electric-leasing';
    let carText = 'Browse EV Models';
    let carSearchButton = document.querySelector('#search-car-button');
    let carSearchUrl = new URL(window.location.origin + '/search');
    carSearchUrl.searchParams.append("search-type", "Car");

    let vanMakeField = document.querySelector('select[name=van-deal-finder-make]');
    let vanModelField = document.querySelector('select[name=van-deal-finder-model]');
    let vanUrl = '/electric-van-leasing';
    let vanText = 'Browse Electric Vans';
    let vanSearchButton = document.querySelector('#search-van-button');
    let vanSearchUrl = new URL(window.location.origin + '/search');
    vanSearchUrl.searchParams.append("search-type", "Van");

    setTimeout(() => { document.getElementById("deal-finder-form").reset() }, 500);

    typeSwitch.forEach((value) => {
      value.addEventListener('change', (e) => {
        typeSections.forEach((v) => {
          (v.dataset.type === e.target.value) ? v.classList.add('active') : v.classList.remove('active')
        })
      })
    })

    // Charger Switches
    chargerSwitch.forEach((value) => {
      value.addEventListener('change', (e) => {
        (e.target.value === 'yes') ? document.querySelector('#charging-button').setAttribute('href', '/ev-charging/home-charging') : document.querySelector('#charging-button').setAttribute('href', '/ev-charging/workplace-charging');
        (e.target.value === 'yes') ? document.querySelector('#charging-button').innerText = 'Home Charging' : document.querySelector('#charging-button').innerText = 'Workplace Charging';
      })
    })

    // Car Switches
    document.querySelectorAll('#q1-switch input').forEach((value => {
      value.addEventListener('change', e => {
        document.querySelectorAll('#car-question-two > div').forEach(v => {
          (v.dataset.type === e.target.value) ? v.classList.add('active') : v.classList.remove('active')
        })
      })
    }))
    document.querySelectorAll('#bodytype-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        document.querySelector('.deal-finder-car .question-three-form').classList.add('active');
        if (e.target.value === '4x4') {
          carSearchUrl.searchParams.delete("body_type");
          carSearchUrl.searchParams.set("body_type[]", e.target.value);
          carSearchUrl.searchParams.append("body_type[]", 'crossover');
          carSearchUrl.searchParams.append("body_type[]", 'estate');
          carSearchUrl.searchParams.append("body_type[]", 'suv');
        } else if (e.target.value === 'any') {
          carSearchUrl.searchParams.delete("body_type[]");
          carSearchUrl.searchParams.set("body_type", e.target.value);
        } else {
          carSearchUrl.searchParams.delete("body_type");
          carSearchUrl.searchParams.set("body_type[]", e.target.value);
        }
        carSearchButton.querySelector('a').setAttribute('href', carSearchUrl.href)
      })
    })
    // document.querySelectorAll('#budget-switch input').forEach((value) => {
    //   value.addEventListener('change', (e) => {
    //     document.querySelector('.deal-finder-car .question-four-form').classList.add('active');
    //     carSearchUrl.searchParams.set("budget", e.target.value);
    //     carSearchButton.querySelector('a').setAttribute('href', carSearchUrl.href)
    //   })
    // })
    document.querySelectorAll('#range-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        document.querySelector('.deal-finder-car .question-four-form').classList.add('active');
        carSearchUrl.searchParams.set("electric_range", e.target.value);
        carSearchButton.querySelector('a').setAttribute('href', carSearchUrl.href)
      })
    })
    document.querySelectorAll('#type-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        carSearchUrl.searchParams.set("type", e.target.value);
        carSearchButton.classList.add('active');
        carSearchButton.querySelector('a').setAttribute('href', carSearchUrl.href)
      })
    })

    // Van Switches
    document.querySelectorAll('#van-q1-switch input').forEach((value => {
      value.addEventListener('change', e => {
        document.querySelectorAll('#van-question-two > div').forEach(v => {
          (v.dataset.type === e.target.value) ? v.classList.add('active') : v.classList.remove('active')
        })
      })
    }))
    document.querySelectorAll('#van-bodytype-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        document.querySelector('.deal-finder-van .van-question-three-form').classList.add('active');
        vanSearchUrl.searchParams.set("van_size", e.target.value);
        vanSearchButton.querySelector('a').setAttribute('href', vanSearchUrl.href)
      })

    })
    // document.querySelectorAll('#van-budget-switch input').forEach((value) => {
    //   value.addEventListener('change', (e) => {
    //     document.querySelector('.deal-finder-van .van-question-four-form').classList.add('active');
    //     vanSearchUrl.searchParams.set("budget", e.target.value);
    //     vanSearchButton.querySelector('a').setAttribute('href', vanSearchUrl.href)
    //   })
    // })
    document.querySelectorAll('#van-range-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        document.querySelector('.deal-finder-van .van-question-four-form').classList.add('active');
        vanSearchUrl.searchParams.set("electric_range", e.target.value);
        vanSearchButton.querySelector('a').setAttribute('href', vanSearchUrl.href)
      })
    })
    document.querySelectorAll('#van-type-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        vanSearchUrl.searchParams.set("type", e.target.value);
        vanSearchButton.classList.add('active');
        vanSearchButton.querySelector('a').setAttribute('href', vanSearchUrl.href)
      })
    })

    // Load Models Dropdown
    function loadModelsCharger($type, $manufacturer) {
      let model_dropdowns;
      ($type == 'car') ? model_dropdowns = document.getElementsByName("deal-finder-model") : model_dropdowns = document.getElementsByName("van-deal-finder-model");
      for (let i = 0; i < model_dropdowns.length; i++) {
        let dropdown = model_dropdowns[i];
        dropdown.length = 0;

        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Model';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;

        let url = '/api/' + $type + '/models/' + $manufacturer + '/ev';

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          for (let x in data) {
            let option = document.createElement('option');
            option.text = data[x];
            option.value = x;
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }

    // Car Dropdowns
    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCharger('car', makeField.value) : loadModelsCharger('car', 0);

      (makeField.value > 0) ? carUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() : carUrl = '/electric-leasing';
      document.getElementById('q2-button').setAttribute('href', carUrl);

      (makeField.value > 0) ? carText = 'Browse ' + makeField.options[makeField.selectedIndex].text + ' Models' : carText = 'Browse EV Models';
      document.getElementById('q2-button').innerText = carText;
    })
    modelField.addEventListener('change', () => {
      (modelField.value > 0) ?
        carUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + modelField.options[modelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() :
        carUrl = ((makeField.value > 0) ? carUrl = '/car-leasing/' + makeField.options[makeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() : carUrl = '/electric-leasing');
      document.getElementById('q2-button').setAttribute('href', carUrl);

      (modelField.value > 0) ?
        carText = 'Browse ' + makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text + ' Models' :
        carText = ((makeField.value > 0) ? carText = 'Browse ' + makeField.options[makeField.selectedIndex].text + ' Models' : carText = 'Browse EV Models');
      document.getElementById('q2-button').innerText = carText;
    })

    // Van Dropdowns
    vanMakeField.addEventListener('change', () => {
      (vanMakeField.value > 0) ? loadModelsCharger('van', vanMakeField.value) : loadModelsCharger('van', 0);

      (vanMakeField.value > 0) ? vanUrl = '/van-leasing/' + vanMakeField.options[vanMakeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() : vanUrl = '/electric-van-leasing';
      document.getElementById('van-q2-button').setAttribute('href', vanUrl);

      (vanMakeField.value > 0) ? vanText = 'Browse ' + vanMakeField.options[vanMakeField.selectedIndex].text + ' Models' : vanText = 'Browse Electric Vans';
      document.getElementById('van-q2-button').innerText = vanText;
    })
    vanModelField.addEventListener('change', () => {
      (vanModelField.value > 0) ?
        vanUrl = '/van-leasing/' + vanMakeField.options[vanMakeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() + '/' + vanModelField.options[vanModelField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() :
        vanUrl = ((vanMakeField.value > 0) ? vanUrl = '/van-leasing/' + vanMakeField.options[vanMakeField.selectedIndex].text.replace(/\s+/g, '-').toLowerCase() : vanUrl = '/electric-van-leasing');
      document.getElementById('van-q2-button').setAttribute('href', vanUrl);

      (vanModelField.value > 0) ?
        vanText = 'Browse ' + vanMakeField.options[vanMakeField.selectedIndex].text + ' ' + vanModelField.options[vanModelField.selectedIndex].text + ' Models' :
        vanText = ((vanMakeField.value > 0) ? vanText = 'Browse ' + vanMakeField.options[vanMakeField.selectedIndex].text + ' Models' : vanText = 'Browse Electric Vans');
      document.getElementById('van-q2-button').innerText = vanText;
    })
  }
});
